import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "production-frequency" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Период выдачи", -1)
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { key: 3 }

import { computed } from 'vue';
import moment from 'moment';
import { uniq } from 'lodash';
import { IAssignment } from '@tools/types';
import { calcMedicationProduction } from '@tools/methods';


export default /*#__PURE__*/_defineComponent({
  __name: 'MedicationProductionFreq',
  props: {
    value: { default: undefined },
    disabled: { type: Boolean, default: false },
    assignment: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({(e: 'change', value: number | null): void}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | number, disabled: boolean, assignment: IAssignment }





const showAnyOption = computed(() => {
    const { medicationCourse, datePlanStart } = props.assignment;
    if (!medicationCourse || props.disabled) {
        return false;
    }

    let schedule;
    try {
        schedule = calcMedicationProduction(
            medicationCourse,
            datePlanStart,
        );
    } catch (err) {
        // schedule service is not initialized yet
        return false;
    }
    return uniq(
        schedule.productionSchedule.flat().map(
            ({ timeTake }) => moment(timeTake).format('DD.MM.YYYY'),
        ),
    ).length < 2;
});

const displayedOptions = computed(
    () => (showAnyOption.value
        ? [
            { period: null, title: 'Нет' },
            { period: 1, title: 'Любой' },
        ] : [
            { period: null, title: 'Нет' },
            { period: 7, title: '7 дней' },
            { period: 14, title: '14 дней' },
            { period: 28, title: '28 дней' },
        ]),
);

const onFreqInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    if (!target) {
        return;
    }
    const value = parseInt(target.value, 10);
    emit('change', Number.isNaN(value) ? null : value);
};

const onFreqSelect = (value: number | null) => {
    emit('change', value);
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _hoisted_2,
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_a_dropdown, {
          key: 0,
          class: "period-input"
        }, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedOptions), (option) => {
                  return (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: option.period,
                    onClick: ($event: any) => (onFreqSelect(option.period))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            (_unref(showAnyOption))
              ? (_openBlock(), _createBlock(_component_a_input, {
                  key: 0,
                  disabled: "",
                  class: "period-input",
                  value: __props.value === 1 ? 'Любой' : 'Нет'
                }, null, 8, ["value"]))
              : (_openBlock(), _createElementBlock("input", {
                  key: 1,
                  type: "number",
                  value: __props.value,
                  min: 0,
                  step: 1,
                  placeholder: "Нет",
                  class: "period-input number-input",
                  onInput: onFreqInput
                }, null, 40, _hoisted_3))
          ]),
          _: 1
        }))
      : (_unref(showAnyOption))
        ? (_openBlock(), _createBlock(_component_a_input, {
            key: 1,
            class: "period-input",
            disabled: "",
            value: __props.value === 1 ? 'Любой' : 'Нет'
          }, null, 8, ["value"]))
        : (_openBlock(), _createElementBlock("input", {
            key: 2,
            type: "number",
            value: __props.value,
            placeholder: "Нет",
            readonly: "",
            class: "period-input number-input"
          }, null, 8, _hoisted_4)),
    (__props.value && !_unref(showAnyOption))
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "дней"))
      : _createCommentVNode("", true)
  ]))
}
}

})